// extracted by mini-css-extract-plugin
export default {"productGallery":"UI-z","inQuickShop":"VI-z"};